import type { FC } from 'react';

import { useSelector } from 'react-redux';

import { ProductSwitcher } from 'components/new-navigation/product-switcher/ProductSwitcher';
import { Right } from 'constants/right';
import { useFetchFeatures } from 'hooks/api/feature-control/use-fetch-features';
import { useParamSelector } from 'hooks/use-param-selector';
import { hasRight, shouldRestrictAgentAccess } from 'store/features/session/selectors';

import { getTopNavigationIds } from '../configuration';
import { ChatbotItem } from '../items/ChatbotItem';
import { HelpDeskItem } from '../items/HelpDeskItem';
import { NavigationItem } from '../items/navigation-item/NavigationItem';

export const TopNavigation: FC = () => {
  const { data } = useFetchFeatures();
  const restrictAgentAccess = useSelector(shouldRestrictAgentAccess);
  const hasAgentsSectionAccess = useParamSelector(hasRight, Right.AgentsSectionAccess);
  const ids = getTopNavigationIds({
    shouldShowTickets: false,
    shouldShowTeam: !restrictAgentAccess && hasAgentsSectionAccess,
  });

  return (
    <>
      {data.productSwitcher && <ProductSwitcher />}
      {ids.map((id) => (
        <NavigationItem key={id} id={id} />
      ))}
      <ChatbotItem />
      <HelpDeskItem />
    </>
  );
};
